import { render, staticRenderFns } from "./HoverEditCardText.vue?vue&type=template&id=58be4817&"
import script from "./HoverEditCardText.vue?vue&type=script&lang=js&"
export * from "./HoverEditCardText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports